<template>
  <div class="container-fluid d-flex justify-content-center align-items-center bg-custom">
    <div class="card custom-card shadow-lg p-4 w-100 mx-3">
      <h1 class="text-center text-light fw-bold mb-4">States List</h1>

      <div class="input-group mb-4">
        <span class="input-group-text bg-gradient text-white">
          <i class="fas fa-search" style="color: black"></i>
        </span>
        <input
          type="text"
          v-model="searchQuery"
          class="form-control search-box"
          placeholder="Search for a State..."
        />
      </div>

      <div v-if="loader" class="text-center my-4 loader-overlay">
        <div class="fancy-loader"></div>
      </div>
      <div class="table-responsive">
        <table v-if="filteredData.length" class="table custom-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Abbreviation</th>
              <th>Tax Applicable</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(state, index) in filteredData" :key="state.id">
              <td>{{ index + 1 }}</td>
              <td>{{ state.name }}</td>
              <td>{{ state.abbreviation }}</td>
              <td>
                <span
                  class="badge"
                  :class="state.tax_applicable ? 'bg-success' : 'bg-danger'"
                >
                  {{ state.tax_applicable ? "Yes" : "No" }}
                </span>
              </td>
              <td>
                <button
                  class="btn btn-warning btn-sm me-2"
                  @click="openUpdateModal(state)"
                >
                  <i class="fas fa-edit"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <p v-if="!filteredData.length" class="text-center text-danger fw-bold no-data">
          No states found.
        </p>
      </div>
    </div>
    <div
      v-if="isUpdateModalVisible"
      class="modal fade show d-flex align-items-center justify-content-center"
      style="backdrop-filter: blur(2px)"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-dark text-white">
            <h3 class="modal-title">Update Tax Applicable Status</h3>
            <button
              type="button"
              class="btn-close"
              @click="isUpdateModalVisible = false"
              style="filter: invert(1);"
            ></button>
          </div>
          <div class="modal-body">
            <div class="p-3 bg-light rounded shadow-sm">
              <div class="mb-2">
                <strong class="text-primary">Name:</strong>
                <span class="text-dark">{{ updatedName }}</span>
              </div>
              <div class="mb-2">
                <strong class="text-primary">Abbreviation:</strong>
                <span class="text-dark">{{ abbreviation }}</span>
              </div>
              <!--  <div class="mb-2">
                <strong class="text-primary">Status:</strong>
                <span class="text-dark">
                  {{ selectedState.tax_applicable ? "Yes" : "No" }}
                </span>
              </div> -->
            </div>
            <label class="fw-bold mt-3 text-secondary"
              >Select Tax Applicable Status</label
            >
            <select v-model="updatedTaxApplicable" class="form-select mt-2">
              <option :value="updatedTaxApplicable" selected>
                {{ updatedTaxApplicable ? "Yes" : "No" }}
              </option>
              <option :value="true" v-if="updatedTaxApplicable !== true">Yes</option>
              <option :value="false" v-if="updatedTaxApplicable !== false">No</option>
            </select>
          </div>
          <div class="modal-footer d-flex justify-content-between">
            <button class="btn btn-secondary" @click="isUpdateModalVisible = false">
              Close
            </button>
            <button
            class="btn btn-success"
           :disabled="isSubmitting || updatedTaxApplicable === originalTaxApplicable"
           @click="updateTaxApplicableStatus"
           data-bs-dismiss="modal"
           >
           Update
         </button>
         <div v-if="loader" class="text-center my-4 loader-overlay">
        <div class="fancy-loader"></div>
        </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { GetStates, UpdateStateTaxApplicableStatus } from "../End Points/api";
export default {
  data() {
    return {
      states: [],
      searchQuery: "",
      isUpdateModalVisible: false,
      selectedState: null,
      updatedTaxApplicable: null,
      updatedName: "",
      updatedAbreviation: "",
      loader: false,
      isSubmitting: false, 
      originalTaxApplicable: null, // holds the original value
    
    };
  },
  watch: {
  selectedState(val) {
    // when modal opens or selection changes
    this.originalTaxApplicable = val.tax_applicable;
    this.updatedTaxApplicable = val.tax_applicable;
  },
},
  computed: {
    filteredData() {
      return this.searchQuery
        ? this.states.filter((state) =>
            state.name.toLowerCase().includes(this.searchQuery.toLowerCase())
          )
        : this.states;
    },
  },
  mounted() {
    this.GetStateData();
  },
  methods: {
    successToast(msg) {
      this.$toast.success(msg, { timeout: 4000 });
    },
    errorToast(msg) {
      this.$toast.error(msg, { timeout: 5000 });
    },
    async GetStateData() {
      this.loader = true;
      try {
        const res = await GetStates();
        if (res.status === 200 && res.data.success) {
          this.states = res.data.data;
        } else {
          console.error("Unexpected API response:", res.data);
        }
      } catch (error) {
        console.error("Error fetching states:", error);
      } finally {
        this.loader = false;
      }
    },

    openUpdateModal(state) {
      this.selectedState = state;
      this.updatedName = state.name;
      this.abbreviation = state.abbreviation;
      this.updatedTaxApplicable = state.tax_applicable;
      this.isUpdateModalVisible = true;
    },
  async updateTaxApplicableStatus() {
    if (this.isSubmitting) return;
    if (this.updatedTaxApplicable === this.originalTaxApplicable) return;

    this.isSubmitting = true;
    this.loader = true;

    try {
    
      const res = await UpdateStateTaxApplicableStatus(this.selectedState.id, {
        tax_applicable: this.updatedTaxApplicable,
      });

      if (res.status === 200) {
        this.originalTaxApplicable = this.updatedTaxApplicable;
        this.selectedState.tax_applicable = this.updatedTaxApplicable;
            this.isUpdateModalVisible = false;
        this.successToast("The status has been updated successfully");
      } else {
        console.error("Error updating state:", res);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      this.isSubmitting = false;
      this.loader = false;
    }
  }


  },
};
</script>

<style scoped>
.custom-card {
  background: linear-gradient(135deg, #0f2027, #203a43, #2c5364);
  color: white;
  border-radius: 15px;
  border: none;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.search-box {
  border: none;
  border-radius: 25px;
  padding: 10px;
  font-size: 16px;
}

.search-input {
  width: 300px;
  height: 40px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  position: fixed;
}

.search-input:focus {
  border-color: #007bff;
  outline: none;
}

.custom-table th,
.custom-table td {
  padding: 12px;
  text-align: center;
  vertical-align: middle;
}

.action-btn {
  transition: all 0.3s ease-in-out;
  border-radius: 50px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: linear-gradient(135deg, #56ab2f, #a8e063);
  color: white;
  font-size: 16px;
}

.action-btn:hover {
  background: linear-gradient(135deg, #2ecc71, #27ae60);
}

.no-data {
  font-size: 1.2rem;
  font-weight: bold;
  color: #e74c3c;
  padding: 20px;
}

@media (max-width: 768px) {
  .custom-card {
    padding: 15px;
  }

  .title {
    font-size: 1.5rem;
  }

  .custom-table th,
  .custom-table td {
    font-size: 0.85rem;
    padding: 8px;
  }

  .action-btn {
    width: 30px;
    height: 30px;
    font-size: 14px;
  }
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Fancy rotating loader */
.fancy-loader {
  width: 60px;
  height: 60px;
  border: 6px solid #e0e0e0;
  border-top: 6px solid #007bff;
  border-radius: 50%;
  animation: slow-spin 1.8s ease-in-out infinite;
  box-shadow: 0 0 10px rgba(0, 123, 255, 0.3);
}

/* Smooth rotation animation */
@keyframes slow-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
